import { SET_CONNECTION_STATUS } from './../actions';

const initialState = { connected: false };
const websocket = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONNECTION_STATUS:
      return ({
        ...state,
        connected: action.connected
      });
    default:
      return state;
  }
};
export default websocket;
export const getSocketConnectionStatus = (state) => state.websocket.connected;


// WEBPACK FOOTER //
// src/reducers/websocket.js